import { render, staticRenderFns } from "./CollectionDepartmentPerformance.vue?vue&type=template&id=9d538900&scoped=true"
import script from "./CollectionDepartmentPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionDepartmentPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionDepartmentPerformance.vue?vue&type=style&index=0&id=9d538900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d538900",
  null
  
)

export default component.exports